import gql from 'graphql-tag';

export const SET_SHADOW_USER_STATUS = gql`
  mutation SET_SHADOW_USER_STATUS($status: String!) {
    selfSetShadowUser(input: { status: $status })
  }
`;
